// This file is generated by scripts/generate-proto-crud-services.ts

// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts,import_extension="
// @generated from file _gen.securitiesReportChunk.service.proto (package securitiesReportChunk.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
  CreateSecuritiesReportChunkRequest,
  CreateSecuritiesReportChunkResponse,
  DeleteSecuritiesReportChunkRequest,
  DeleteSecuritiesReportChunkResponse,
  GetSecuritiesReportChunkByIdRequest,
  GetSecuritiesReportChunkByIdResponse,
  GetSecuritiesReportChunksByDocDescriptionRequest,
  GetSecuritiesReportChunksByDocDescriptionResponse,
  GetSecuritiesReportChunksByDocIdRequest,
  GetSecuritiesReportChunksByDocIdResponse,
  GetSecuritiesReportChunksByDocTypeCodeRequest,
  GetSecuritiesReportChunksByDocTypeCodeResponse,
  GetSecuritiesReportChunksByEdinetCodeRequest,
  GetSecuritiesReportChunksByEdinetCodeResponse,
  GetSecuritiesReportChunksByEdinetFileIdRequest,
  GetSecuritiesReportChunksByEdinetFileIdResponse,
  GetSecuritiesReportChunksByErrorMessageRequest,
  GetSecuritiesReportChunksByErrorMessageResponse,
  GetSecuritiesReportChunksByFilerNameRequest,
  GetSecuritiesReportChunksByFilerNameResponse,
  GetSecuritiesReportChunksByFormCodeRequest,
  GetSecuritiesReportChunksByFormCodeResponse,
  GetSecuritiesReportChunksByLayerRequest,
  GetSecuritiesReportChunksByLayerResponse,
  GetSecuritiesReportChunksByOrdinanceCodeRequest,
  GetSecuritiesReportChunksByOrdinanceCodeResponse,
  GetSecuritiesReportChunksByOriginalFilenameRequest,
  GetSecuritiesReportChunksByOriginalFilenameResponse,
  GetSecuritiesReportChunksByParentChunkIdRequest,
  GetSecuritiesReportChunksByParentChunkIdResponse,
  GetSecuritiesReportChunksByPeriodEndRequest,
  GetSecuritiesReportChunksByPeriodEndResponse,
  GetSecuritiesReportChunksByPeriodStartRequest,
  GetSecuritiesReportChunksByPeriodStartResponse,
  GetSecuritiesReportChunksBySecCodeRequest,
  GetSecuritiesReportChunksBySecCodeResponse,
  GetSecuritiesReportChunksBySubmissionDateRequest,
  GetSecuritiesReportChunksBySubmissionDateResponse,
  GetSecuritiesReportChunksByTitleRequest,
  GetSecuritiesReportChunksByTitleResponse,
  GetSecuritiesReportChunksByTitlesStackRequest,
  GetSecuritiesReportChunksByTitlesStackResponse,
  GetSecuritiesReportChunksByTrimmedChunkContentRequest,
  GetSecuritiesReportChunksByTrimmedChunkContentResponse,
  GetSecuritiesReportChunksRequest,
  GetSecuritiesReportChunksResponse,
  UpdateSecuritiesReportChunkRequest,
  UpdateSecuritiesReportChunkResponse,
} from './_gen.securitiesReportChunk.service_pb'
import { MethodKind } from '@bufbuild/protobuf'

/**
 * @generated from service securitiesReportChunk.v1.SecuritiesReportChunkService
 */
export const SecuritiesReportChunkService = {
  typeName: 'securitiesReportChunk.v1.SecuritiesReportChunkService',
  methods: {
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunkById
     */
    getSecuritiesReportChunkById: {
      name: 'GetSecuritiesReportChunkById',
      I: GetSecuritiesReportChunkByIdRequest,
      O: GetSecuritiesReportChunkByIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByEdinetFileId
     */
    getSecuritiesReportChunksByEdinetFileId: {
      name: 'GetSecuritiesReportChunksByEdinetFileId',
      I: GetSecuritiesReportChunksByEdinetFileIdRequest,
      O: GetSecuritiesReportChunksByEdinetFileIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksBySubmissionDate
     */
    getSecuritiesReportChunksBySubmissionDate: {
      name: 'GetSecuritiesReportChunksBySubmissionDate',
      I: GetSecuritiesReportChunksBySubmissionDateRequest,
      O: GetSecuritiesReportChunksBySubmissionDateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByEdinetCode
     */
    getSecuritiesReportChunksByEdinetCode: {
      name: 'GetSecuritiesReportChunksByEdinetCode',
      I: GetSecuritiesReportChunksByEdinetCodeRequest,
      O: GetSecuritiesReportChunksByEdinetCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksBySecCode
     */
    getSecuritiesReportChunksBySecCode: {
      name: 'GetSecuritiesReportChunksBySecCode',
      I: GetSecuritiesReportChunksBySecCodeRequest,
      O: GetSecuritiesReportChunksBySecCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByDocId
     */
    getSecuritiesReportChunksByDocId: {
      name: 'GetSecuritiesReportChunksByDocId',
      I: GetSecuritiesReportChunksByDocIdRequest,
      O: GetSecuritiesReportChunksByDocIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByDocDescription
     */
    getSecuritiesReportChunksByDocDescription: {
      name: 'GetSecuritiesReportChunksByDocDescription',
      I: GetSecuritiesReportChunksByDocDescriptionRequest,
      O: GetSecuritiesReportChunksByDocDescriptionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByPeriodStart
     */
    getSecuritiesReportChunksByPeriodStart: {
      name: 'GetSecuritiesReportChunksByPeriodStart',
      I: GetSecuritiesReportChunksByPeriodStartRequest,
      O: GetSecuritiesReportChunksByPeriodStartResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByPeriodEnd
     */
    getSecuritiesReportChunksByPeriodEnd: {
      name: 'GetSecuritiesReportChunksByPeriodEnd',
      I: GetSecuritiesReportChunksByPeriodEndRequest,
      O: GetSecuritiesReportChunksByPeriodEndResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByDocTypeCode
     */
    getSecuritiesReportChunksByDocTypeCode: {
      name: 'GetSecuritiesReportChunksByDocTypeCode',
      I: GetSecuritiesReportChunksByDocTypeCodeRequest,
      O: GetSecuritiesReportChunksByDocTypeCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByFilerName
     */
    getSecuritiesReportChunksByFilerName: {
      name: 'GetSecuritiesReportChunksByFilerName',
      I: GetSecuritiesReportChunksByFilerNameRequest,
      O: GetSecuritiesReportChunksByFilerNameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByOrdinanceCode
     */
    getSecuritiesReportChunksByOrdinanceCode: {
      name: 'GetSecuritiesReportChunksByOrdinanceCode',
      I: GetSecuritiesReportChunksByOrdinanceCodeRequest,
      O: GetSecuritiesReportChunksByOrdinanceCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByFormCode
     */
    getSecuritiesReportChunksByFormCode: {
      name: 'GetSecuritiesReportChunksByFormCode',
      I: GetSecuritiesReportChunksByFormCodeRequest,
      O: GetSecuritiesReportChunksByFormCodeResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByOriginalFilename
     */
    getSecuritiesReportChunksByOriginalFilename: {
      name: 'GetSecuritiesReportChunksByOriginalFilename',
      I: GetSecuritiesReportChunksByOriginalFilenameRequest,
      O: GetSecuritiesReportChunksByOriginalFilenameResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByErrorMessage
     */
    getSecuritiesReportChunksByErrorMessage: {
      name: 'GetSecuritiesReportChunksByErrorMessage',
      I: GetSecuritiesReportChunksByErrorMessageRequest,
      O: GetSecuritiesReportChunksByErrorMessageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByLayer
     */
    getSecuritiesReportChunksByLayer: {
      name: 'GetSecuritiesReportChunksByLayer',
      I: GetSecuritiesReportChunksByLayerRequest,
      O: GetSecuritiesReportChunksByLayerResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByTitlesStack
     */
    getSecuritiesReportChunksByTitlesStack: {
      name: 'GetSecuritiesReportChunksByTitlesStack',
      I: GetSecuritiesReportChunksByTitlesStackRequest,
      O: GetSecuritiesReportChunksByTitlesStackResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByTitle
     */
    getSecuritiesReportChunksByTitle: {
      name: 'GetSecuritiesReportChunksByTitle',
      I: GetSecuritiesReportChunksByTitleRequest,
      O: GetSecuritiesReportChunksByTitleResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByParentChunkId
     */
    getSecuritiesReportChunksByParentChunkId: {
      name: 'GetSecuritiesReportChunksByParentChunkId',
      I: GetSecuritiesReportChunksByParentChunkIdRequest,
      O: GetSecuritiesReportChunksByParentChunkIdResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunksByTrimmedChunkContent
     */
    getSecuritiesReportChunksByTrimmedChunkContent: {
      name: 'GetSecuritiesReportChunksByTrimmedChunkContent',
      I: GetSecuritiesReportChunksByTrimmedChunkContentRequest,
      O: GetSecuritiesReportChunksByTrimmedChunkContentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.GetSecuritiesReportChunks
     */
    getSecuritiesReportChunks: {
      name: 'GetSecuritiesReportChunks',
      I: GetSecuritiesReportChunksRequest,
      O: GetSecuritiesReportChunksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.CreateSecuritiesReportChunk
     */
    createSecuritiesReportChunk: {
      name: 'CreateSecuritiesReportChunk',
      I: CreateSecuritiesReportChunkRequest,
      O: CreateSecuritiesReportChunkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.UpdateSecuritiesReportChunk
     */
    updateSecuritiesReportChunk: {
      name: 'UpdateSecuritiesReportChunk',
      I: UpdateSecuritiesReportChunkRequest,
      O: UpdateSecuritiesReportChunkResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc securitiesReportChunk.v1.SecuritiesReportChunkService.DeleteSecuritiesReportChunk
     */
    deleteSecuritiesReportChunk: {
      name: 'DeleteSecuritiesReportChunk',
      I: DeleteSecuritiesReportChunkRequest,
      O: DeleteSecuritiesReportChunkResponse,
      kind: MethodKind.Unary,
    },
  },
} as const
